import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';
import AddIcon from '../images/add.png';

const moment = require('moment');

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc',
  },
};

const claimantColumns = [
  {
    headerName: '',
    field: 'add',
    cellRenderer: 'addWorkOrderCellRenderer',
    width: 30,
    resizable: true,
  },
  {
    headerName: 'Claimant name',
    field: 'claimantName',
    cellRenderer: 'claimantNameCellRenderer',
    width: 150,
    resizable: true,
  },
  {
    headerName: 'Claim Number',
    field: 'clmClaimNumber',
    sortable: true,
    width: 150,
    resizable: true,
  },
  { headerName: 'Phone', field: 'clmPhone', width: 100, resizable: true },
  { headerName: 'Employer', field: 'clmEmployer', width: 150, resizable: true },
  {
    headerName: 'Date of Injury',
    field: 'clmDateOfInjuryStart',
    width: 80,
    resizable: true,
  },
  {
    headerName: 'DOB',
    field: 'clmDOB',
    width: 80,
    valueFormatter: (params) =>
      params.value ? moment(params.value).format('MM/DD/YYYY') : '',
    resizable: true,
  },
  {
    headerName: 'Rep Name',
    field: 'repName',
    valueGetter: (params) =>
      `${params.data.repLastName}, ${params.data.repFirstName}`,
    width: 150,
    resizable: true,
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    width: 200,
    resizable: true,
  },
];

export class ClaimantTableDefault extends Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  autoSizeUnspecifiedColumns = () => {
    if (!this.gridColumnApi) return;
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: claimantColumns,
      rowData: this.props.claimants,
      context: {
        componentParent: this.props,
        gridApi: this.gridApi,
        setModal: this.props.setModal,
        addWorkOrder: this.props.addWorkOrder,
        state: this.props.state,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      components: {
        addWorkOrderCellRenderer: AddWorkOrderCellRenderer,
        claimantNameCellRenderer: ClaimantNameCellRenderer,
      },
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.props.handleDoubleClick,
      onRowClicked: this.props.handleClick,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '400px',
        }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}

/************************************************************************************
 *             Cell Renderer Classes needed for Ag-Grid-React                       *
 ************************************************************************************/
class AddWorkOrderCellRenderer extends Component {
  handleAddClick = () => {
    // Accessing the context or props to call the function
    const { data, context } = this.props;
    context.addWorkOrder(data);
  };

  render() {
    return (
      <div className="x-grid-cell-inner">
        <img
          src={AddIcon}
          onClick={this.handleAddClick}
          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
          alt="Add"
        />
      </div>
    );
  }
}

class ClaimantNameCellRenderer extends Component {
  render() {
    const { data } = this.props; // ag-Grid passes the data prop automatically to the renderer
    const name =
      `${data.clmLastName}, ${data.clmFirstName},` +
      '(' +
      `${data.clientAbbrv}` +
      ')';

    if (data.hasClaimantDupWO) {
      return <span style={{ color: 'red' }}>{name}</span>;
    } else {
      return <span>{name}</span>;
    }
  }
}
